import { Pipe, PipeTransform } from '@angular/core';
import { Beneficiaire } from '../../models/beneficiaire';

@Pipe({
	name: 'filterBeneficiaireByName'
})
export class FilterBeneficiaireByNamePipe implements PipeTransform {
	transform(beneficiaires: Beneficiaire[], filter: string, applyFilter: boolean): Beneficiaire[] {
		if (!applyFilter || 
			!beneficiaires ||
			!filter ||
			beneficiaires === null ||
			filter === null ||
			filter === ''
		) {
			return beneficiaires;
		}

		const lowerFilter = filter.toLowerCase();

		return beneficiaires.filter((b: Beneficiaire) => {
			const lastName = b.lastName?.toLowerCase() || '';
			const firstName = b.firstName?.toLowerCase() || '';
			const email = b.email?.toLowerCase() || '';

			return (
				lastName.includes(lowerFilter) ||
				firstName.includes(lowerFilter) ||
				email.includes(lowerFilter)
			);
		});
	}
}
